/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class MenuItem {
  icon: string;
  text: string;
  hotkey: string;
  action: string;
  isShow: boolean;

  static createItem(icon: string, text: string, action: string, isShow: boolean = true, hotkey: string = ''): MenuItem {
    let menu: MenuItem = new MenuItem();
    menu.icon = icon;
    menu.text = text;
    menu.action = action;
    menu.isShow = isShow;
    menu.hotkey = hotkey;
    return menu;
  }
}
